import { isVisibleOnSellerProfile } from "@/lib/auction-visibility";

type RawListingRow = Record<string, unknown>;

export function passesProfileListingViewerFilter(
  listing: RawListingRow,
  options: {
    viewerId: string | null;
    profileOwnerId: string;
    isProfileOwner: boolean;
    canViewDev: boolean;
    now?: Date;
  },
): boolean {
  const now = options.now ?? new Date();
  if (listing.is_unlisted && !options.isProfileOwner) return false;
  const isPublished =
    !listing.scheduled_publish_at || new Date(String(listing.scheduled_publish_at)) <= now;
  if (!isPublished && !options.isProfileOwner) return false;
  if (listing.is_dev_listing && !options.isProfileOwner && !options.canViewDev) return false;
  if (
    !isVisibleOnSellerProfile(
      listing as Parameters<typeof isVisibleOnSellerProfile>[0],
      options.viewerId,
      options.profileOwnerId,
    )
  ) {
    return false;
  }
  return true;
}

export function filterProfileCollectionsForViewer<T extends { listings: unknown[] }>(
  collections: T[],
  isProfileOwner: boolean,
): T[] {
  if (isProfileOwner) return collections;
  return collections.filter((collection) => collection.listings.length > 0);
}
